export default "/images/vendor/flag-icon-css/flags/4x3/cc.svg?5cc309bf03b8035d8bdb61ef1d5f2db2";